/**
 * page9 (#420) — ContactPerson read-seam hook.
 * A kontakt-lista a dedikált `GET /partners-direct/:partnerId/contact-persons`
 * endpointról jön (pinnelt kontrakt, runtime Zod-parse az api-rétegben).
 */

import { getContactPersons, type ContactPersonRead } from '@/api/partners';
import { useCallback, useEffect, useState } from 'react';

export function useContactPersons(partnerId: string | undefined): {
  contactPersons: ContactPersonRead[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
} {
  const [contactPersons, setContactPersons] = useState<ContactPersonRead[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchContacts = useCallback(async () => {
    if (!partnerId) {
      setContactPersons([]);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      setContactPersons(await getContactPersons(partnerId));
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch contact persons';
      setError(message);
      console.error('Error fetching contact persons:', err);
    } finally {
      setIsLoading(false);
    }
  }, [partnerId]);

  useEffect(() => {
    void fetchContacts();
  }, [fetchContacts]);

  return { contactPersons, isLoading, error, refetch: fetchContacts };
}
